export let childList = "child_list"
export let ChildInfo = "Child Info"
export let tp_info = "tp_info"
export let TP = "TP"
export let Customer_registration = "Customer Registration"
export let  Warranty_return = "Warranty Return"
export let  Warranty_return_update = "Warranty Return Update"

export let level1_info = 'level1_info'
export let Weight_Validation_Status = 'Weight Validation Status'
export let Level1_Details = "Level 1 Details"
export let Level8_Details = "Level 8 Details"
export let Pairing_Info = 'Pairing Information'
export let trace_info = 'trace_info'
export let product_data = 'product_data'
export let ProductDetails = "Product Details"
export let functionalTestingHeader = "Functional Testing Parameters"
export let visualTestingHeader = "Visual Testing Parameters"
export let finalQcHeader = "Final QC Parameters"
export let Dispatch = "Dispatch"

export const hidePaginationDropdown = ["Supplier Inventory","Linewise Production",
                "Batch Wise Production","Supplier Wise Dispatch",
                "Generated IOT History","IOT","PDI",
                "Weighing","Warranty Return",
                "Customer Registration",
                "Return Center Binding",
                "Reclamation","Pairing",
                "Final QC","Bulk IOT",
                "Lot Creation","GRN","GI"]


 
 